import React, { useCallback, useEffect, useState } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { Layout } from 'antd';
import { KoAttachment, KoButton, KoCheckBox, KoColorPicker, KoDataTableEdit, KoDate, KoDateFormatter, KoDateTime, KoDP, KoForm,
  KoInput, KoLoader, KoNano, KoNumber, KoRadio, KoRating,
  KoSelect, KoSignature, KoSlider, KoSwitch, KoText,
  KoTextArea, KoTimePicker, KoTitle,
  KoTooltips, KoDrawer,
  KoCollapse,
  KoDescription,
  KoToast,
  KoTag,
  KoModal} from 'packages';
import KoIcon from '@kwapio/icons';
import { useSelector } from 'react-redux';
import { getCookie } from 'shared/utils/cookies';
import { useDispatch } from 'react-redux';
import { getSettings } from 'shared/store/settingsSlice';
import { getUserById } from 'shared/store/userByIdSlice';
import { useParams } from 'react-router';
import { workspaceAPI } from '../workspace.service';
import { FormItemTypes, SystemFields } from './dndForm/formItemTypes';
import DndContext from './dndForm/dndContext';
import DraggableItem from './dndForm/draggableItem';
import DroppableArea from './dndForm/droppableArea';
import KoRichTextEditor from 'packages/richText';
import FieldPropertiesEditor from './dndForm/currentProperties';

import styles from './curd.module.scss';
import FormRenderer from './formrenderer';
const FormCurd = () => {
  const userById = useSelector(state => state?.userById);
  const accountById = useSelector(state => state?.accountById);
  const accountDetails = accountById['data'];
  const [formItems, setFormItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(null);
  const [form] = KoForm.useForm();
  const [currentProperties, setCurrentProperties] = useState({});
  const [currentRecord, setCurrentRecord] = useState();
  const dispatch = useDispatch();
  const { workspaceId, formId } = useParams();
  let userDetails = userById['data'];
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState();
  const [openProps, setOpenProps] = useState(false);
  const [showPerviewModal, setShowPerviewModal] = useState(false);

  const { Header } = Layout;
  const [dataSource] = useState([{
    key: KoNano('INV'),
    index: 1
  }, {
    key: KoNano('INV'),
    index: 2
  }, {
    key: KoNano('INV'),
    index: 3
  }
  ]);
  useEffect(() => {
    if (getCookie('userId')) {
      dispatch(getSettings(getCookie('accountId')));
      dispatch(getUserById(getCookie('userId')));
    }
  }, []);

  useEffect(() => {
    if (workspaceId && formId) {
      if(formId === 'create') {
        setIsLoading(false);
        form.setFieldsValue({
          columns: 6,
          name: '',
          description: ''
        });
        return;
      }
      workspaceAPI.getFromById(workspaceId, formId).then((res) => {
        setIsLoading(false);
        form.setFieldsValue(res['form']);
        setFormData(res['form']);
        setCurrentRecord(res['form']);
        setFormItems(res['form']['fields']);
      });
    }
  }, [workspaceId, formId]);



  // const LAYOUTS = [{
  //   columns: 'card',
  //   icon: 'CardFilled',
  //   name: 'Card'
  // }, {
  //   columns: 1,
  //   icon: 'ColumnOneFilled',
  //   name: 'Column 1'
  // }, {
  //   columns: 2,
  //   icon: 'ColumnTwoFilled',
  //   name: 'Column 2'
  // }, {
  //   columns: 3,
  //   icon: 'ColumnThreeFilled',
  //   name: 'Column 3'
  // }, {
  //   columns: 4,
  //   icon: 'ColumnFourFilled',
  //   name: 'Column 4'
  // }];


  const handleDrop = (item) => {
    let id = KoNano('FID');
    let colSpan = 2;
    if (['heading', 'subHeading', 'fieldset', 'textarea', 'checkbox', 'table', 'invoicetable', 'upload'].includes(item.type)) {
      colSpan = 6;
    }
    const newItem = {
      ...item,
      id,
      colSpan
    };
    setFormItems((prevItems) => [...prevItems, newItem]);
  };


  const handleSaveProperties = (currentProperties) => {
    delete currentProperties['name'];
    delete currentProperties['description'];
    setFormItems((prevItems) =>
      prevItems.map((item) =>
        item.id === currentItem.id ? { ...item, ...currentProperties } : item
      )
    );
  };

  const moveItem = (dragIndex, hoverIndex) => {
    const updatedItems = [...formItems];
    const [movedItem] = updatedItems.splice(dragIndex, 1);
    updatedItems.splice(hoverIndex, 0, movedItem);
    setFormItems(updatedItems);
  };

  const handleDeleteItem = (itemId) => {
    setFormItems((prevItems) => prevItems.filter((item) => item.id !== itemId));
  };


  const DraggableFormItem = ({ item, index }) => {
    const [, drag] = useDrag({
      type: 'FORM_ITEM',
      item: { index }
    });

    const [, drop] = useDrop({
      accept: 'FORM_ITEM',
      hover: (draggedItem) => {
        if (draggedItem.index !== index) {
          moveItem(draggedItem.index, index);
          draggedItem.index = index;
        }
      }
    });

    return (
      <div className={styles.formItems} ref={(node) => drag(drop(node))}>
        {renderFormItem(item)}
      </div>
    );
  };


  const renderDefaultFormItem = (item, inputComponent) => (
    <div className={`${styles.formItemCls} ${item.id === currentItem?.id ? styles.active : ''}`}>
      <div className={styles.heading}>
        <div className={styles.actions}>
          <KoButton
            type="text"
            iconBtn={true}
            icon={<KoIcon name="EditOutlined" />}
            onClick={() => {
              openPropertyEditor(item);
            }}
          />
          <KoButton
            type="text"
            iconBtn={true}
            icon={<KoIcon name="DeleteOutlined" />}
            onClick={() => handleDeleteItem(item.id)}
          />
        </div>
      </div>
      <KoForm.Item key={item.id} label={item.label}>
        {inputComponent}
      </KoForm.Item>
    </div>
  );

  const renderFormItem = (item) => {
    switch (item.type) {
    case 'heading':
      return renderDefaultFormItem(item, <KoTitle level={item.level || 3} text={item.heading} />);
    case 'subHeading':
      return renderDefaultFormItem(item, <KoDescription placeholder={item.placeholder || 'Input'} />);
    case 'input':
      return renderDefaultFormItem(item, <KoInput placeholder={item.placeholder || 'Input'} />);
    case 'textarea':
      return renderDefaultFormItem(item, <KoTextArea placeholder={item.placeholder || 'Input'} />);
    case 'richtext':
      return renderDefaultFormItem(item, <KoRichTextEditor placeholder={item.placeholder || 'Input'} />);
    case 'number':
      return renderDefaultFormItem(item, <KoNumber placeholder={item.placeholder || 'Input'} />);

    // Select / Multi-Select
    case 'select':
    case 'tags':
    case 'user':
    case 'customer':
    case 'project':
    case 'country':
      return renderDefaultFormItem(
        item,
        <KoSelect
          mode={item.isMultiSelect ? 'multiple' : ''}
          options={item.options}
          placeholder={item.placeholder || 'Select'}
        />
      );

    // Multiple Choice Inputs
    case 'checkbox':
      return renderDefaultFormItem(item, <KoCheckBox direction={item.direction ? 'horizontal' : 'vertical'} options={item.options} />);
    case 'radio':
      return renderDefaultFormItem(item, <KoRadio value={item.value} direction={item.direction ? 'horizontal' : 'vertical'} options={item.options || []} />);
    case 'slider':
      return renderDefaultFormItem(item, <KoSlider min={item.min || 0} max={item.max || 100} />);
    case 'rating':
      return renderDefaultFormItem(item, <KoRating max={item.max || 5} />);

    // Table
    case 'table':
      return renderDefaultFormItem(
        item,
        <KoDataTableEdit
          dataSource={dataSource}
          form={form}
          defaultColumns={item.options}
        />
      );

    // Date & Time Pickers
    case 'date':
      return renderDefaultFormItem(item, <KoDate dateFormat="DD-MMM-YYYY" />);
    case 'time':
      return renderDefaultFormItem(item, <KoTimePicker />);
    case 'datetime':
      return renderDefaultFormItem(item, <KoDateTime format="DD-MMM-YYYY HH:mm" />);
    case 'yesno':
      return renderDefaultFormItem(item, <KoSwitch defaultChecked checkedChildren={item.checkedChildren} unCheckedChildren={item.unCheckedChildren} />);

    // File / Media Inputs
    case 'upload':
      return renderDefaultFormItem(item, <KoAttachment placeholder={item.placeholder || 'Upload Files'} />);
    case 'color':
      return renderDefaultFormItem(item, <KoColorPicker />);
    case 'signature':
      return renderDefaultFormItem(item, <KoSignature />);
    // case 'map':
    //   return renderDefaultFormItem(item, <KoMapPicker placeholder="Select Location" />);

    // Website
    case 'website':
      return renderDefaultFormItem(item, <KoInput placeholder={item.placeholder || 'Website URL'} />);

    // Layout Elements
    case 'fieldset':
    case 'divider':
      return (
        <div className={styles.formItemCls}>
          <div className={styles.heading}>
            <div className={styles.actions}>
              <KoButton
                type="text"
                iconBtn={true}
                icon={<KoIcon name="EditOutlined" />}
                onClick={() => {
                  form.resetFields();
                  openPropertyEditor(item);
                }}
              />
              <KoButton
                type="text"
                iconBtn={true}
                icon={<KoIcon name="DeleteOutlined" />}
                onClick={() => handleDeleteItem(item.id)}
              />
            </div>
          </div>
          <KoForm.Item key={item.id}>
            <fieldset>
              <legend>{item?.label}</legend>
            </fieldset>
          </KoForm.Item>
        </div>
      );

    default:
      return null;
    }
  };





  const openPropertyEditor = (item) => {
    setCurrentItem(item);
    setCurrentProperties(item);
    form.setFieldsValue(item);
    setOpenProps(true);
  };

  const handleSubmit = useCallback(values => {
    let data = form.getFieldsValue();
    data['fields'] = formItems;
    if(formId === 'create') {
      data['formId'] = KoNano('FRM');
      data['name']= formData?.name || 'Form';
    }
    form.setFieldsValue(data);
    setIsLoading(true);
    workspaceAPI.createOrUpdateForm(workspaceId, data, formId).then(
      (data) => {
        setIsLoading(false);
        form.resetFields();
        KoToast.success(`Form ${formId === 'create' ? 'created' : 'updated'} successfully`);
      },
      (err) => {
        setIsLoading(false);
      }
    );
  });

  const items = [
    {
      key: 'fields',
      label: <KoTitle text="Fields" level={5} />,
      children:  <div className={styles.widgetOption}>
        {FormItemTypes.map((item, index) => {
          return (
            <DraggableItem key={index} datatype={item.datatype} id={"input1"} type={item?.type} label={item?.label}>
              <div className={styles.cardWarp} key={index}>
                <KoText className={styles.titleColor} text={`${item.label}`} />
                <div className={styles.card}>
                  <KoIcon name={item.icon} />
                </div>
              </div>
            </DraggableItem>
          );
        })}
      </div>
    },
    {
      key: '3',
      label:  <KoTitle text="System Fields" level={5} />,
      children:   <div className={styles.widgetOption}>
        {SystemFields.map((item, index) => {
          return (
            <DraggableItem key={index} id="input1" type={item?.type} label={item?.label}>
              <div className={styles.cardWarp} key={index}>
                <KoText className={styles.titleColor} text={`${item.label}`} />
                <div className={styles.card}>
                  <KoIcon name={item.icon} />
                </div>
              </div>
            </DraggableItem>
          );
        })}
      </div>
    }
  ];


  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader />}
      <Header className={styles.shallowHeader}></Header>
      <Header className={styles.globalHeader}>
        <div className={styles.docHeader}>
          <div className={styles.docHeaderLeft}>
            <div className={styles.iconWrapper}>
              <KoIcon name="FileOutlined" size={32} />
            </div>
            <KoInput className={styles.docHeaderInput} placeholder={'Enter template name'} value={formData?.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
          </div>
          <div className={styles.docHeaderRight}>
            <KoTag iscount={false} custom={true} value={formData?.status === 0 ? 'Draft' : 'Live'} color={formData?.status === 0 ? "add" : "approved" } />
            <KoButton label={'Save'} color="primary" variant="outlined" onClick={() => form.submit()} />
            <KoButton label={'Preview'} color="purple" variant="outlined" onClick={()=>setShowPerviewModal(true)} />
            <KoButton label={'Publish'} type='primary' />
            <KoTooltips title={<div className={styles.lastUpdated}>
              <KoText className={styles.lastUpdatedText} text={'Last Updated:'} />
              <KoDateFormatter className={styles.lastUpdatedDate} data={formData?.updatedAt !== '0001-01-01T00:00:00Z' ? formData?.updatedAt : formData?.createdAt} />
            </div>} placement="bottom">
              <KoButton iconBtn={true} color="default" variant="filled" icon={<KoIcon width={16} height={16} name={'LogOutlined'} />} />
            </KoTooltips>
            <div className={styles.userWrapper} >
              {accountDetails?.companyName && <KoText ellipsis={true} className={styles.name} text={`${accountDetails?.companyName}.`} />}
              <div className={`${styles.headCircle}  ${styles[userDetails ?
                userDetails?.profile?.firstName?.charAt(0).toLowerCase() : 'a']}`}>
                {userDetails?.profile?.['logo'] ?
                  <KoDP shape={'circle'} logo={userDetails?.profile?.logo} width={userDetails?.profile?.logo?.[0]?.name ? 30 : 30} height={userDetails?.profile?.logo?.[0]?.name ? 30 : 30} />
                  :
                  <KoText className={`${styles.letter}`} text={userDetails?.profile?.firstName?.charAt(0)} />
                }
              </div>
            </div>
          </div>
        </div>
      </Header>
      <DndContext>
        <div className={styles.content}>
          <div className={`${styles.widgetsOptions} dndCollapse`}>
            <div className={styles.widgetsBody}>
              {/* <KoTitle text="Layouts" level={5} />
              <div className={`${styles.widgetOption} ${styles.layoutOption}`}>
                {LAYOUTS.map((item, index) => {
                  return (
                    <div className={`${styles.cardWarp}`} key={index} onClick={() => form.setFieldValue('columns', item.columns)} >
                      <KoText className={styles.titleColor} text={`${item.name}`} />
                      <div className={`${styles.card}  ${currentCol === item.columns ? styles.activeCol : ''}`}>
                        <KoIcon name={item.icon} width={35} height={35} />
                      </div>
                    </div>
                  );
                })}
              </div> */}
              <KoCollapse expandIconPosition="end" accordion defaultActiveKey={['fields']} ghost items={items} />
            </div>
          </div>
          <div className={styles.formDropWrapper}>
        
            <KoForm layout="vertical" form={form} column={6} initialValues={currentRecord} onFinish={handleSubmit} onSubmit={handleSubmit}>
              <div className={styles.formHeader}>
                <KoTitle text="Form Fields" level={5} />
                <KoForm.Item name={'name'} label={'Form Name'} hidden>
                  <KoInput placeholder={'Enter template name'} />
                </KoForm.Item>
                <KoForm.Item name={'columns'} label={'Columns'} hidden>
                  <KoNumber placeholder={'Enter description'} />
                </KoForm.Item>
                <KoForm.Item name={'description'} label={'Description'}hidden>
                  <KoInput placeholder={'Enter description'} />
                </KoForm.Item>
              </div>
              <DroppableArea onDrop={handleDrop} column={6} formItems={formItems}>
                {formItems.length > 0 ? (
                  formItems.map((item, index) => (
                    <div
                      key={item.id}
                      style={{
                        gridColumn: `span ${item.colSpan || 3}`,
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                    >
                      <DraggableFormItem item={item} index={index} />
                    </div>
                  ))
                ) : (
                  <div className={styles.noData}>
                    <KoText className={styles.noDataText} text={'Drop Here'} />
                  </div>
                )}
              </DroppableArea>


            </KoForm>
          </div>
        </div>
        <KoDrawer
          placement="right"
          closable={true}
          title={
            <div className={styles.headerTitle}>
              <KoTitle text={`Field Properties`} level={4} className={styles.title} />
            </div>
          }
          onClose={() => setOpenProps(false)}
          open={openProps}
          width={650}
          footer={false}
        >
          {(openProps) &&
           <div className={styles.formProperties}>
             <div className={styles.updateFieldsWrapper}>
               <FieldPropertiesEditor
                 form={form}
                 currentItem={currentItem}
                 currentRecord={currentRecord}
                 currentProperties={currentProperties}
                 FormItemTypes={FormItemTypes}
                 handleSaveProperties={handleSaveProperties}
               />
             </div>
           </div>
          }
        </KoDrawer>
      </DndContext>

      <KoModal
        title={formData?.name}
        centered
        open={showPerviewModal}
        handleOk={() => { setShowPerviewModal(false); }}
        onClose={() => { setShowPerviewModal(false); }}
        width={'80vw'}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setShowPerviewModal(false)} />,
          <KoButton key='save' label='Save' type='primary' onClick={() => setShowPerviewModal(false)} />
        ]}
      >
        <FormRenderer workspaceId={workspaceId} formId={formId}/>
      </KoModal>

    </div>
  );
};

export default FormCurd;